import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ethers } from "ethers";
import axios from "axios";
import RightBackgroundImage from "../../Images/backgroundImage.jpg";
import {
  isSupportedNFT,
  ownerOf,
  checkAllowance,
  isApprovedForAll,
  setApprovalForAll,
  listNFT,
  listInBatch,
  updateSupportedNFT,
  updateNFTSupportForStaking,
} from "./contractData";
import Loading from "../../Components/Loader";
import ConnectWalletPopup from "../../Components/ConfirmPopup";
import {
  nftContractABI,
  metaspaceNFTMarketplaceAddress,
} from "../../config/data.js";
import Swal from "sweetalert2";

const Root = styled.div`
  background-image: url(${RightBackgroundImage});
  background-size: cover;
  background-position: center;
  height: 100vh;
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem 8rem;
`;
const TextContractContainer = styled.div`
  margin: 3rem 0;
`;
const TextWrapper = styled.div`
  width: 80%;
`;
const ContractTextWrapper = styled.div`
  margin: 10px 0;
`;

const ContractText = styled.text`
  font-size: 28px;
  font-family: sans-serif;
  font-weight: 500;
  margin: 0 20px;
`;
const Text = styled.input`
  width: 100%;
  font-size: 16px;
  padding: 15px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  border: none;
  margin-left: 20px;
  outline: none;
`;

const RadioTextWrapper = styled.div``;
const RadioText = styled.text``;
const RadioButtonWrapper = styled.div`
  font-size: 24px;
  margin: 5px 20px;
`;
const RadioButton = styled.input`
  padding: 0 40px;
`;
const RadioContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 5rem 0;
  width: 80%;
`;
const Button = styled.button`
  padding: 10px 2rem;
  font-size: 18px;
  border-radius: 25px;
  outline: none;
  border: none;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  margin: 0 10px;
`;
const Span = styled.span`
  margin: 15px 10px;
`;
const SelectWrapper = styled.div``;
const Select = styled.select`
  width: 80%;
  font-size: 16px;
  padding: 15px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  border: none;
  margin-left: 20px;
  cursor: pointer;
  outline: none;
`;
const Option = styled.option`
  width: 80%;
  font-size: 16px;
  padding: 15px 10px !important;
  background-color: rgba(255, 255, 255, 0.1);
  color: Black !important;
  border-radius: 8px;
  border: none;
  margin-left: 20px;
  cursor: pointer !important;
  outline: none;
`;

const TokenIdValues = styled.text`
  font-size: 26px;
  font-weight: 500;
  /* padding-left:15px; */
  /* padding-top:10px; */
  padding: 20px 0px 0 0px;
`;

const ListingNft = ({ allContractDetails }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const [values, setValues] = useState();
  const [contract, setContract] = useState("");
  const [contract2, setContract2] = useState("");
  const [contract3, setContract3] = useState("");
  const [currency, setCurrency] = useState("");
  const [tokenIdArray, setTokenIdArray] = useState([]);
  const [fixedArray, setFixedArray] = useState([]);
  const [priceArray, setPriceArray] = useState([]);
  const [priceForAPIArray, setPriceForAPIArray] = useState([]);
  const [price, setPrice] = useState();
  const [batchListingDisable, setBatchListingDisable] = useState(false);
  const [error, setError] = useState({
    contract: "",
    currency: "",
    hash: "",
    baseid: "",
    typeid: "",
    skinid: "",
    tokenid: "",
    price: "",
  });
  const [isSupported, setIsSupported] = useState(true);
  const [isSupportedStaking, setIsSupportedStaking] = useState(true);
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [perform, setPerform] = useState("");
  const [payload, setPayload] = useState([]);
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [data, setData] = useState({
    isFixed: false,
    price: "",
    currency: "",
    tokenId: "",
    contractAddress: "",
    baseId: "",
    typeId: "",
    skinId: "",
  });
  //for batch listing states
  const [hash, setHash] = useState(null);
  const [baseid, setBaseid] = useState(null);
  const [typeid, setTypeid] = useState(null);
  const [skinid, setSkinid] = useState(null);
  const [tokenid, setTokenid] = useState(null);
  const [isAuctioned, setIsAuctioned] = useState(false);
  const handleSubmitUpdateSupported = () => {
    setLoading(true);

    updateSupportedNFT(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      contract2,
      isSupported
    )
      .then((response) => {
        if (response != null) {
          setLoading(false);
          setPerform("NFT supported status changed!");
          setShowCreatedPopup(true);
          setContract("");
          setContract2("");
          setIsSupported(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setPerform(err?.response?.data?.message||err?.message || "Something went wrong");
        setShowCreatedPopup(true);
        setContract("");
        setContract2("");
        setIsSupported(true);
      });
  };

  const handleSubmitUpdateSupportedStaking = () => {
    setLoading(true);

    updateNFTSupportForStaking(
      allContractDetails?.nftStakingContract,
      contract3,
      isSupportedStaking
    )
      .then((response) => {
        if (response != null) {
          setLoading(false);
          setPerform("NFT is eligible now for staking!");
          setShowCreatedPopup(true);
          setContract("");
          setContract2("");
          setContract3("");
          setIsSupportedStaking(true);
          setIsSupported(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setPerform(err?.response?.data?.message||err?.message || "Something went wrong");
        setShowCreatedPopup(true);
        setContract("");
        setContract2("");
        setContract3("");
        setIsSupportedStaking(true);
        setIsSupported(true);
      });
  };
  const handleInputKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();

      const trimmedValue = event.target.value.trim();
      if (trimmedValue !== "") {
        const newValues = trimmedValue.split(",").map((item) => item.trim()); // Split values by comma
        setValues((prevValues) => [...prevValues, ...newValues]); // Update values state
      }

      event.target.value = "";
    }
  };
  const handleChangeSupported = (e) => {
    const { value } = e.target;
    setIsSupported(value === "true" ? true : false);
  };
  const handleChangeSupportedStaking = (e) => {
    const { value } = e.target;
    setIsSupportedStaking(value === "true" ? true : false);
  };
  const handleChange = (e) => {
    const { value } = e.target;
    setData({
      ...data,
      isFixed: value === "auction" ? true : false,
    });
  };

  useEffect(() => {
    if (allContractDetails?.address) {
      setAddress(allContractDetails.address);
    }
  }, [allContractDetails]);

  const clearData = () => {
    setData({
      isFixed: false,
      price: "",
      currency: "",
      tokenId: "",
      contractAddress: "",
      baseId: "",
      typeId: "",
      skinId: "",
    });
  };

  const checkIsUSDT = (address) => {
    if (address === "0xAEC6DF3D233d2343166309e636117ECa36D0C34e") {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency) => {
    console.log("price", price);
    // parseUnits for multiply
    // formatUnits for divide
    return checkIsUSDT(currency)
      ? ethers.utils.parseUnits(price, 6)
      : ethers.utils.parseUnits(price, 18);
  };
  const handleResetOneArray=()=>{
    let payload1=[];
    let tokenarr=Array.isArray(payload)&&Array.isArray(payload[7])&&[...payload[7]];
    if(Array.isArray(tokenarr)&&tokenarr.length>1){
      tokenarr.pop();
      setTokenIdArray(tokenarr)
    let pricearr=[...payload[8]];
    pricearr.pop();
    setPriceArray(pricearr);
    let realPriceArr=[...payload[10]]
    realPriceArr.pop();
    setPriceForAPIArray(realPriceArr);

    let fixedarr=[...payload[9]];
    fixedarr.pop();
    setFixedArray(fixedarr)
    payload1.push(
      payload[0],
      payload[1],
      payload[2],
      payload[3],
      payload[4],
      payload[5],
      payload[6],
      tokenarr,
      pricearr,
      fixedarr,
      realPriceArr,
    );
    setPayload(payload1);
    }else{
      setPayload([])
    }
    
  }
  const handleAdd = () => {
    setError({
      contract: "",
      currency: "",
      hash: "",
      baseid: "",
      typeid: "",
      skinid: "",
      tokenid: "",
      price: "",
    });
    if (contract == null || contract == undefined || contract == "") {
      setError({ ...error, contract: "Please add contract address" });
      return;
    } else if (currency == null || currency == undefined || currency == "") {
      setError({ ...error, currency: "please select currency" });
      return;
    } else if (hash == null || hash == undefined || hash == "") {
      setError({ ...error, hash: "please add hash" });
      return;
    } else if (baseid == null || baseid == undefined || baseid == "") {
      setError({ ...error, baseid: "please add base id" });
      return;
    } else if (typeid == null || typeid == undefined || typeid == "") {
      setError({ ...error, typeid: "please add type id" });
      return;
    } else if (skinid == null || skinid == undefined || skinid == "") {
      setError({ ...error, skinid: "please add skin id" });
      return;
    } else if (tokenid == null || tokenid == undefined || tokenid == "") {
      setError({ ...error, tokenid: "please add token id" });
      return;
    } else if (price == null || price == undefined || price == "") {
      setError({ ...error, price: "please add price" });
      return;
    }
    setBatchListingDisable(true);

    const payload1 = [];
    const tokenarr = [...tokenIdArray];
    tokenarr.push(tokenid);
    setTokenIdArray(tokenarr);
    const pricearr = [...priceArray];
    const realPriceArr=[...priceForAPIArray];
    pricearr.push(convertedPrice(price));
    realPriceArr.push(price);
    setPriceArray(pricearr);
    setPriceForAPIArray(realPriceArr);
    
    const fixedarr = [...fixedArray];
    fixedarr.push(data.isFixed);
    setFixedArray(fixedarr);
    payload1.push(
      contract,
      currency,
      data.currency,
      hash,
      baseid,
      typeid,
      skinid,
      tokenarr,
      pricearr,
      fixedarr,
      realPriceArr,
    );
    console.log(payload1, "batch listing payload");
    setPayload(payload1);

    // setPayload((prev) => [...prev, contract]);
    // setTokenIdArray((prev) => [...prev, values]);
    // setPriceArray((prev) => [...prev, price]);
    // setFixedArray((prev) => [...prev, isFixed]);
    // setPayload((prev) => [...prev, tokenIdArray]);
    // setPayload((prev) => [...prev, currency]);
    // setPayload((prev) => [...prev, priceArray]);
    // setPayload((prev) => [...prev, fixedArray]);
    // console.log(payload,tokenIdArray,fixedArray,priceArray);
    // const payload1 = [];
    // const tokenarr = tokenIdArray;
    // const pricearr = priceArray;
    // const fixedArr = fixedArray;
    // tokenarr.push(Number(values));
    // pricearr.push(convertedPrice(data.currency));
    // fixedArr.push(data.auction);
    // payload1.push(contract);
    // payload1.push(tokenarr);
    // payload1.push(currency);
    // payload1.push(pricearr);
    // payload1.push(fixedArr);
    // setPayload(payload1);
  };

  const callNftListing = async () => {
    const res = await isSupportedNFT(
      allContractDetails.metaspaceNFTMarketplaceContract,
      data.contractAddress
    );

    console.log("res", res);
    if (res === true) {
      const updatedPrice = convertedPrice(data.currency);

      console.log("updatedPrice", updatedPrice);

      await listNFT(
        allContractDetails.metaspaceNFTMarketplaceContract,
        data.contractAddress,
        data.tokenId,
        data.currency,
        updatedPrice,
        data.isFixed
      )
        .then(async (res) => {
          axios
            .post(
              `${baseUrl}/nftmarketplace/api/v1/update_listing_status/${data.contractAddress.toLowerCase()}/${
                data.tokenId
              }`,
              {
                baseId: data.baseId,
                typeId: data.typeId,
                skinId: data.skinId,
                price: data.price,
                currency: currency,
                isFixed: data.isFixed,
                hash: data.hash,
              }
            )
            .then((res) => {
              if (res.data.success === true) {
                // clearData();
                setLoading(false);
                setPerform("Your Nft has been listed.");

                setShowCreatedPopup(true);
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setPerform(err?.response?.data?.message||err?.message || "Something went wrong");
          setShowCreatedPopup(true);
        });
    } else {
      setLoading(false);
      alert(`${res}`);
    }
  };

  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails.signer
    );
  };

  const onConfirmClick = async () => {
    setLoading(true);
    console.log("data outside", data);
    console.log("listing changes");
    if (data?.price > 0 && data?.currency !== "") {
      try {
        console.log("data", data);
        const nftContract = await getNFTContract(data?.contractAddress);

        const ownerAddress = await ownerOf(nftContract, data?.tokenId);

        // if (ownerAddress === address) {
        console.log("nftContract", nftContract);
        console.log(
          "metaspaceNFTMarketplaceAddress",
          metaspaceNFTMarketplaceAddress
        );
        console.log("allContractDetails.address", allContractDetails.address);

        const getIsApprovedForAll = await isApprovedForAll(
          nftContract,
          allContractDetails.address,
          metaspaceNFTMarketplaceAddress
        );

        console.log("getIsApprovedForAll", getIsApprovedForAll);

        if (getIsApprovedForAll === true) {
          await callNftListing();
        } else {
          console.log(
            "nftContract, metaspaceNFTMarketplaceAddress",
            nftContract,
            metaspaceNFTMarketplaceAddress
          );
          await setApprovalForAll(nftContract, metaspaceNFTMarketplaceAddress);

          await callNftListing();
        }
        // } else {
        //   setLoading(false);
        //   alert(" you are not a owner user");
        // }
      } catch (err) {
        // clearData();
        setLoading(false);
        console.log(err, "listingerror");
        setPerform(
          err?.response?.data?.message || err?.message || "Something went wrong"
        );
        setShowCreatedPopup(true);
      }
    } else {
      setLoading(false);
      // alert("Please field all fields.");
      Swal.fire({
        icon: "error",
        // text: " you are not a owner user.",
        text: " Please field all fields.",
      });
    }
  };

  const onBatchCall = async () => {
    setLoading(true);
    try {
      console.log(allContractDetails.metaspaceNFTMarketplaceContract,'marketplace contract for list in batch ')
      console.log(data.contractAddress,'contract address')
      console.log(data.currency,'currency for batch listing')
      console.log(payload[7],'tokenid')
      console.log(payload[8],'price')
      console.log(payload[9],'auction')
      await listInBatch(
        allContractDetails.metaspaceNFTMarketplaceContract,
        data.contractAddress,
        payload[7],
        data.currency,
        payload[8],
        payload[9]
      )
        .then(async (res) => {
          if (res !== null) {
            // clearData();
            //api call here
            // https://uat-nftbe.metaspacechain.com/nftmarketplace/api/v1/

            let data1 = {
              currency: payload[1],
              skinId: payload[6],
              typeId: payload[5],
              baseId: payload[4],
              hash: payload[3],
              tokenId: payload[7],
              price: payload[10],
              isFixed: payload[9],
            };

            let config = {
              method: "post",
              maxBodyLength: Infinity,
              url: `${process.env.REACT_APP_API_URL}/nftmarketplace/api/v1/update_batch_listing/${contract}`,
              data: data1,
            };

            axios
              .request(config)
              .then((response) => {
                setLoading(false);
            setPerform("Your Nft has been listed.");
            setShowCreatedPopup(true);
            setPayload([]);
            setBatchListingDisable(true)
              })
              .catch((error) => {
                console.log(error);
                setLoading(false);
                setPerform(
                  error?.response?.data?.message || err?.message || "Something went wrong"
                );
                setShowCreatedPopup(true);
              });
          }
        })
        .catch((err) => {
          setLoading(false);
          setPerform(
            err?.response?.data?.message || err?.message || "Something went wrong"
          );
          setShowCreatedPopup(true);
        });
    } catch (err) {
      // clearData();
      setLoading(false);
      setPerform(
        err?.response?.data?.message || err?.message || "Something went wrong"
      );
      setShowCreatedPopup(true);
    }
  };
  return (
    <>
      {loading && <Loading />}
      <Root>
        <Container>
          <h1>Update NFT Support for Listing</h1>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Contract Address</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="0X129836.... 8989"
                value={contract2}
                onChange={(e) => {
                  setContract2(e.target.value.toLowerCase());
                }}
              />
            </TextWrapper>
          </TextContractContainer>
          <ContractTextWrapper>
            <ContractText>Supported</ContractText>
          </ContractTextWrapper>
          <RadioContainer>
            <RadioButtonWrapper>
              <RadioButton
                value="true"
                name="platform"
                type="radio"
                checked={isSupported === true}
                onChange={handleChangeSupported}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <Span>True</Span>
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                value="false"
                name="platform"
                type="radio"
                checked={isSupported === false}
                onChange={handleChangeSupported}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <Span> False</Span>
            </RadioButtonWrapper>
          </RadioContainer>
          <Button onClick={handleSubmitUpdateSupported}>Submit</Button>
        </Container>
        <Container>
          <h1>Update NFT Support for Staking</h1>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Contract Address</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="0X129836.... 8989"
                value={contract3}
                onChange={(e) => {
                  setContract3(e.target.value.toLowerCase());
                }}
              />
            </TextWrapper>
          </TextContractContainer>
          <ContractTextWrapper>
            <ContractText>Supported</ContractText>
          </ContractTextWrapper>
          <RadioContainer>
            <RadioButtonWrapper>
              <RadioButton
                value="true"
                name="platform"
                type="radio"
                checked={isSupportedStaking === true}
                onChange={handleChangeSupportedStaking}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <Span>True</Span>
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                value="false"
                name="platform"
                type="radio"
                checked={isSupportedStaking === false}
                onChange={handleChangeSupportedStaking}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <Span> False</Span>
            </RadioButtonWrapper>
          </RadioContainer>
          <Button onClick={handleSubmitUpdateSupportedStaking}>Submit</Button>
        </Container>
        <Container>
          <h1>List NFT</h1>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Contract Address</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                disabled={batchListingDisable}
                placeholder="0X129836.... 8989"
                value={data.contractAddress}
                onChange={(e) => {
                  setData({
                    ...data,
                    contractAddress: e.target.value.toLowerCase(),
                  });
                  setContract(e.target.value.toLowerCase());
                }}
              />
              {error?.contract != "" ? <div>{error?.contract}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>

          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Currency </ContractText>
            </ContractTextWrapper>
            <SelectWrapper>
              <Select
                disabled={batchListingDisable}
                onChange={(e) => {
                  setData({
                    ...data,
                    currency: e.target.value,
                  });
                  const selectedIndex = e.target.selectedIndex;
                  const selectedOptionText =
                    e.target.options[selectedIndex].textContent;
                  setCurrency(selectedOptionText);
                }}
                value={data.currency}
              >
                <Option value="">Select Currency</Option>
                <Option value="0x0000000000000000000000000000000000001010">
                  MATIC
                </Option>
                <Option value="0xc2132D05D31c914a87C6611C10748AEb04B58e8F">
                  USDT
                </Option>
                <Option value="0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6">
                  MLD
                </Option>
              </Select>
              {error?.currency != "" ? <div>{error?.currency}</div> : <></>}
            </SelectWrapper>
          </TextContractContainer>

          {/* <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Base ID </ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="number"
                placeholder="18"
              
              />
            </TextWrapper>
          </TextContractContainer>

          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Type ID </ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="number"
                placeholder="52"
                
              />
            </TextWrapper>
          </TextContractContainer>

                    
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Skin ID </ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="number"
                placeholder="52"
               
              />
            </TextWrapper>
          </TextContractContainer> */}

          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText>Hash</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                disabled={batchListingDisable}
                type="text"
                placeholder="62.5"
                id="inputField"
                onKeyPress={handleInputKeyPress}
                value={data.hash}
                onChange={(e) => {
                  setData({
                    ...data,
                    hash: e.target.value,
                  });
                  setValues(e.target.value);
                  setHash(e.target.value);
                }}
              />
              {error?.hash != "" ? <div>{error?.hash}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Base ID</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                disabled={batchListingDisable}
                type="text"
                placeholder="4000"
                id="inputField"
                onKeyPress={handleInputKeyPress}
                value={data.baseId}
                onChange={(e) => {
                  setData({
                    ...data,
                    baseId: e.target.value,
                  });
                  setValues(e.target.value);
                  setBaseid(e.target.value);
                }}
              />
              {error?.baseid != "" ? <div>{error?.baseid}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Type ID</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                disabled={batchListingDisable}
                type="text"
                placeholder="4100"
                id="inputField"
                onKeyPress={handleInputKeyPress}
                value={data.typeId}
                onChange={(e) => {
                  setData({
                    ...data,
                    typeId: e.target.value,
                  });
                  setValues(e.target.value);
                  setTypeid(e.target.value);
                }}
              />
              {error?.typeid != "" ? <div>{error?.typeid}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText>Skin ID</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                disabled={batchListingDisable}
                type="text"
                placeholder="4120"
                id="inputField"
                onKeyPress={handleInputKeyPress}
                value={data.skinId}
                onChange={(e) => {
                  setData({
                    ...data,
                    skinId: e.target.value,
                  });
                  setValues(e.target.value);
                  setSkinid(e.target.value);
                }}
              />
              {error?.skinid != "" ? <div>{error?.skinid}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Token Id</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="0"
                id="inputField"
                onKeyPress={handleInputKeyPress}
                value={data.tokenId}
                onChange={(e) => {
                  setData({
                    ...data,
                    tokenId: e.target.value,
                  });
                  setValues(e.target.value);
                  setTokenid(e.target.value);
                }}
              />
              {error?.tokenid != "" ? <div>{error?.tokenid}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>

          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Price </ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="number"
                placeholder="0.0001"
                value={data.price}
                onChange={(e) => {
                  setData({
                    ...data,
                    price: e.target.value,
                  });
                  setPrice(e.target.value);
                }}
              />
              {error?.price != "" ? <div>{error?.price}</div> : <></>}
            </TextWrapper>
          </TextContractContainer>
          <ContractTextWrapper>
            <ContractText>Fixed / Auction</ContractText>
          </ContractTextWrapper>
          <RadioContainer>
            <RadioButtonWrapper>
              <RadioButton
                value="fixed"
                name="auction"
                type="radio"
                onChange={handleChange}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <Span>Fixed</Span>
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                value="auction"
                name="auction"
                type="radio"
                onChange={handleChange}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <Span> Auction</Span>
            </RadioButtonWrapper>
          </RadioContainer>

          <>
            
           <div style={{border:"1px solid white",padding:"18px",borderRadius:"10px",width:"59vw",marginTop:'20px'}}>
           <TokenIdValues>Payload for Batch Listing :</TokenIdValues>
           <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Contract Address : </strong></div> <div>{payload.length > 0 && `${payload[0]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Currency : </strong></div> <div>{payload.length > 0 && `${payload[1]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Currency Address : </strong></div> <div>{payload.length > 0 && `${payload[2]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Hash : </strong></div> <div>{payload.length > 0 && `${payload[3]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Base ID : </strong></div> <div>{payload.length > 0 && `${payload[4]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Type ID : </strong></div> <div>{payload.length > 0 && `${payload[5]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Skin ID : </strong></div> <div>{payload.length > 0 && `${payload[6]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Token ID : </strong></div> <div>{payload.length > 0 && `${payload[7]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Price : </strong></div> <div>{payload.length > 0 && `${payload[10]}`}</div></div>
            <div style={{display:"flex",fontSize:"24px",fontWeight:300}}><div style={{marginRight:"5px"}}><strong>Is Auction : </strong></div> <div>{payload.length > 0 && `${payload[9]}`}</div></div>
           </div>
          </>

          <ButtonWrapper>
            <Button
              onClick={() => {
                if (payload?.length >= 1) {
                  onBatchCall();
                } else {
                  onConfirmClick();
                }
              }}
            >
              Confirm
            </Button>
            <Button onClick={handleAdd}>Add</Button>
            <Button onClick={handleResetOneArray}>Reset One</Button>
            <Button onClick={()=>{setPayload([]);setTokenIdArray([]);setPriceArray([]);setPriceForAPIArray([]);setFixedArray([]);setBatchListingDisable(false)}}>Reset All</Button>
          </ButtonWrapper>
          {showCreatedPopup && (
            <ConnectWalletPopup
              showPopup={showCreatedPopup}
              setShowPopup={setShowCreatedPopup}
              onClickFun={(e) => {
                e.preventDefault();
                setShowCreatedPopup(false);
              }}
              text={`${perform}`}
            ></ConnectWalletPopup>
          )}
        </Container>
      </Root>
    </>
  );
};

export default ListingNft;
